import { SignalBinding } from "signals";
import { CloseCommand } from "slotworks/commands/comms/close-command";
import Components from "slotworks/components/components";
import betModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Services } from "slotworks/services/services";
import { HoldSpinControl } from "slotworks/smart-ui/controls/spin/hold-spin-control";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SuperState from "slotworks/state-machine/states/superstate";
import Timer from "slotworks/utils/timer";

export default class WinCycle extends SuperState {

    public static HOLD_SPIN_DELAY: number = 0;

    protected readyToExit: boolean;
    protected pendingExit: boolean;

    protected signalBindings: SignalBinding[] = [];

    private isFreeSpins: boolean;
    private holdSkipTimer: number;

    public onEnter() {
        this.signalBindings.push(betModel.onCreditSizeChanged.add(() => this.collapse()));
        this.signalBindings.push(betModel.onCreditPerLineChanged.add(() => this.collapse()));

        const gameplay = GameState.getCurrentGame();

        this.readyToExit = false;
        this.pendingExit = false;
        this.isFreeSpins = false;

        const recordWin = gameplay.getCurrentRecord().cashWon;
        const totalWin = gameplay.getTotalWin();

        const record = gameplay.getCurrentRecord();
        let closeGame = true;

        if (record instanceof SpinRecord) {
            if (record.getFreespinsWon() > 0 || record.isBonusTriggered()) {
                closeGame = false;
            }
        }

        if (record instanceof FreespinRecord) {
            this.isFreeSpins = true;
            closeGame = false;
        }

        if (gameplay.isComplete()) {
            closeGame = true;
        }

        Services.transaction.setWinnings(recordWin, totalWin).then(() => this.rollupComplete());

        if (closeGame) {

            SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);

            CloseCommand().then(() => {
                this.readyToExit = true;

                if (this.pendingExit) {
                    this.complete();
                } else {
                    SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
                    SmartUIFlags.set(SmartUIFlag.IDLE, true);
                    if (!this.isFreeSpins) {
                        Services.transaction.setBalance(GameState.getCurrentGame().balance);
                    }
                }
            });
        } else {
            this.readyToExit = true;
            if (this.pendingExit) {
                this.complete();
            }
        }
    }

    public collapse() {
        Services.transaction.setTotalWin(0);

        super.collapse();
    }

    public onSkip() {
        if (!this.isFreeSpins) {
            Services.transaction.setBalance(GameState.getCurrentGame().balance);
        }
        SmartUIFlags.set(SmartUIFlag.IDLE, false);

        if (!this.holdSkipTimer) {
            if (HoldSpinControl.isHeld) {
                this.holdSkipTimer = Timer.setTimeout(() => {
                    this.holdSkipTimer = null;
                    this.skip();
                }, WinCycle.HOLD_SPIN_DELAY);
            } else {
                this.skip();
            }
        }
    }

    public onExit() {
        if (!this.isFreeSpins) {
            Services.transaction.setBalance(GameState.getCurrentGame().balance);
        }

        Components.celebrateWin.cleanup();
        Components.celebrateWin.hide();

        for (const binding of this.signalBindings) {
            binding.detach();
        }
        this.signalBindings = [];
    }

    protected rollupComplete() {
        //
    }
}
